import { endOfMonth, startOfMonth } from "date-fns";
import { formatDateForAPI } from "utils/utils";



export const startDateForBillables = "2024-01-01"

export const startOfMonthDate = formatDateForAPI(startOfMonth(new Date()));
export const endOfMonthDate = formatDateForAPI(endOfMonth(new Date()));

export const statusWiseBillingDateFilters = {

  billing_date: { _gte: startDateForBillables, _lte: endOfMonthDate },
};
export const statusWiseDueDateFilters = {
  due_date: { _gte: startDateForBillables, _lte: endOfMonthDate },
};

export const statusWiseCollectedDateFilters = {
  collected_date: { _gte: startOfMonthDate, _lte: endOfMonthDate },
};

export const statusWiseCancelledDateFilters = {
  date_updated: { _gte: startOfMonthDate, _lte: endOfMonthDate },
};

export const getExpectedBillingInfo = (status) => {
  switch (status) {
    case "contracted":
      return {
        label: "Expected Billing",
        info: "Total amount expected to be billed for contracted work, default billables before end of current month"
      };
    case "pending_invoice":
      return {
        label: "Expected Billing",
        info: "Total amount pending for invoice generation, default billables before end of current month"
      };
    case "billed":
      return {
        label: "Expected Billing",
        info: "Total amount that has been billed to clients (all time)"
      };
    default:
      return {
        label: "Expected Billing",
        info: "Total expected billing amount across all billable work"
      };
  }
};

export const getCollectedBillingInfo = (status) => {
  switch (status) {
    case "collected":
      return {
        label: "Collected Billing",
        info: "Total amount successfully collected, default for this month"
      };
    default:
      return {
        label: "Collected Billing",
        info: "Total amount collected from all completed billing transactions"
      };
  }
};